import script from "./Material_Strength.vue?vue&type=script&setup=true&lang=js"
export * from "./Material_Strength.vue?vue&type=script&setup=true&lang=js"

import "./Material_Strength.vue?vue&type=style&index=0&id=93f89842&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-93f89842"]])

export default __exports__